import { render, staticRenderFns } from "./ForgotPasswordVerifyOTP.vue?vue&type=template&id=e9f8256a&scoped=true"
import script from "./ForgotPasswordVerifyOTP.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerifyOTP.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordVerifyOTP.vue?vue&type=style&index=0&id=e9f8256a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f8256a",
  null
  
)

export default component.exports